module.exports = __webpack_public_path__ + "static/media/img_8.637843ab.png";